import {createApp} from 'vue';
import * as components from './vue/components/index';
import * as collectionComponents from './vue/components/collection';
import '../styles/main.css';

import './modules/lab_branding';
import './modules/modal';
import './modules/header';
import {addToCart} from './modules/cart';
import {
  publishEngagementTime,
  publishScrollDepth,
  publishCtaClick,
  publishMenuClick,
} from './modules/customer-events';

theme.cart = theme.cart || {};
theme.customerEvents = theme.customerEvents || {};

theme.cart.addToCart = addToCart;
theme.customerEvents.publishCtaClick = publishCtaClick;
theme.customerEvents.publishMenuClick = publishMenuClick;
theme.customerEvents.publishScrollDepth = publishScrollDepth;
theme.customerEvents.publishEngagementTime = publishEngagementTime;

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

/* Create Vue instances function */
const createVueApp = () => {
  const app = createApp({});
  const allComponents = {...components, ...collectionComponents};

  Object.entries(allComponents).forEach(([name, module]) => {
    app.component(name, module);
  });

  return app;
};

const vueElements = document.querySelectorAll('[vue]');

if (vueElements) {
  vueElements.forEach((el) => {
    createVueApp().mount(el);
  });
}

/* properly render vue components on user insert in the theme editor */
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.value.includes('vue')) {
      const vueElement = event.target.querySelectorAll('[vue]');
      if (vueElement) {
        vueElement.forEach((el) => {
          createVueApp().mount(el);
        });

        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('modal:reregister'));
        }, 150);
      }
    }
  });
}

/** ********************************************************************************** */
/** ********************************DO NOT EDIT BELOW********************************* */
/** ********************************************************************************** */

/**
 * Custom DOMready function
 * @param {*} callback
 */
const labDOMready = (callback) => {
  if (document.readyState !== 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
};

/**
 * Use this event listener to run your JS after the DOM is ready
 */
labDOMready(() => {
  document.dispatchEvent(new CustomEvent('page:loaded'));

  // Prevent Tracking in the Theme Editor
  if (!Shopify.designMode) {
    // Init engagement time tracking
    theme.customerEvents.publishEngagementTime();

    // Init scroll depth tracking
    window.addEventListener('scroll', () => {
      theme.customerEvents.publishScrollDepth();
    });
  }
});
